import { NavLink } from "react-router-dom";
import ContactImg from "assets/images/Receptionist.svg";
import VirtualMeeting from "assets/images/virtual-meeting.svg";
import { PhoneIcon } from "assets/icons/PhoneIcon";
import ScrollReveal from "components/common/ScrollReveal";

const ContactUs = () => {
    return (
        <section>
            <div className="container">
                <ScrollReveal variant="scale">
                    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                        <div className="text-center lg:text-left">
                            <span className="section-eyebrow">Get in Touch</span>
                            <h2 className="section-title">
                                Have a question? Let&apos;s talk.
                            </h2>
                            <p className="text-secondary/80 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
                                For inquiries and more information, please
                                don&apos;t hesitate to contact us. Our team
                                is ready to assist you and ensure you have
                                all the details you need.
                            </p>
                            <NavLink to="/contact-us" className="btn">
                                <PhoneIcon /> Contact Us
                            </NavLink>
                        </div>

                        <div className="relative hidden md:block">
                            <div className="relative z-10 max-w-sm mx-auto">
                                <img
                                    src={ContactImg}
                                    alt="Contact Us"
                                    className="w-full"
                                />
                            </div>
                            <div className="absolute -bottom-4 -left-4 w-2/5 max-w-[140px] z-20">
                                <img
                                    src={VirtualMeeting}
                                    alt="Virtual consultation"
                                    className="w-full rounded-xl shadow-lg border-2 border-gray-100"
                                />
                            </div>
                        </div>
                    </div>
                </ScrollReveal>
            </div>
        </section>
    );
};

export default ContactUs;
